export const parseOAuthParameters = (datum) => {
  if (!datum) return;

  // Handle both Immutable.js Map and plain object
  if (datum.get && typeof datum.get === "function") {
    // Immutable.js Map
    return {
      baseUrl: datum.get("baseUrl"),
      parameters: {
        client_id: datum.getIn(["parameters", "client_id"]),
        response_type: datum.getIn(["parameters", "response_type"]),
        scope: datum.getIn(["parameters", "scope"]),
        redirect_uri: datum.getIn(["parameters", "redirect_uri"]),
        state: datum.getIn(["parameters", "state"]),
      },
    };
  } else {
    // Plain object
    return {
      baseUrl: datum.baseUrl,
      parameters: {
        client_id: datum.parameters?.client_id,
        response_type: datum.parameters?.response_type,
        scope: datum.parameters?.scope,
        redirect_uri: datum.parameters?.redirect_uri,
        state: datum.parameters?.state,
      },
    };
  }
};
